import { Fragment } from 'react'

export const getFragmentedText = (text: string) => {
  return text.split('\n').map((line, index, array) => (
    <Fragment key={index}>
      {line}
      {index !== array.length - 1 && <br />}
    </Fragment>
  ))
}
